export default __webpack_public_path__ + "static/media/product-school.8ab43c10.webp";